import React, { useMemo } from 'react';
import InputPercentage from './InputPercentage';
import InputText from './InputText';
import InputNumber from './InputNumber';
import InputRadio from './InputRadio';
import InputCheckbox from './InputCheckbox';
import FadeInOutComponent from './FadeInComponent';

const componentsMap = {
  'input-perc': InputPercentage,
  'input-text': InputText,
  'input-num': InputNumber,
  radio: InputRadio,
  checkbox: InputCheckbox,
};

const QuestionItem = ({
  question,
  handleAssessmentChange,
  isVisible,
  handleValue,
  handleChecked,
  userRole,
  translations,
  assessment,
  areInputsDisabled,
  isMonitoring,
}) => {
  const Component = componentsMap[question.type];
  const isPremium = useMemo(() => userRole === 4, [userRole]);
  if (!Component) return null;

  return (
    <FadeInOutComponent isVisible={isVisible}>
      <Component
        question={question}
        handleAssessmentChange={handleAssessmentChange}
        handleValue={handleValue}
        handleChecked={handleChecked}
        isPremium={isPremium}
        translations={translations} // Pass translations prop
        assessment={assessment} // Pass assessment prop
        areInputsDisabled={areInputsDisabled} // Pass areInputsDisabled prop
        isMonitoring={isMonitoring}
      />
    </FadeInOutComponent>
  );
};

export default QuestionItem;
